<div class="carousel">
  <owl-carousel-o [options]="customOptions">
    <ng-template carouselSlide *ngFor="let i of numberOfPagesRange()">
      <div class="content-area">
        <app-circle>{{ getIcon(i) }}</app-circle>
        <app-paragraph>{{ getText(i) }}</app-paragraph>
      </div>
    </ng-template>
  </owl-carousel-o>
  <div class="footer">
    <app-anchor id="login-route-click" (click)="emitFinish()" footer>
      {{ anchorText }}
    </app-anchor>
  </div>
</div>
